import type { Route } from '../core/types';
import { activeVehicle, type Settings } from '../core/settings';
import { reportedRestrictionViolation } from './reportedRestrictions';

export function vehicleProfileKey(settings: Settings): string {
  const v = activeVehicle(settings);
  return JSON.stringify([v?.id, v?.kind, v?.height, v?.width, v?.weight]);
}

export function vehicleViolation(route: Route, settings?: Settings): string | null {
  const reported = settings && reportedRestrictionViolation(route, settings);
  if (reported) return reported;
  for (const leg of route.legs) {
    for (const notice of leg.notifications ?? []) {
      if (notice.type === 'violation' && notice.subtype === 'pointExclusion') {
        return 'Route crosses an excluded road section. Choose another route.';
      }
      if (notice.type === 'violation' && ['maxHeight', 'maxWidth', 'maxWeight'].includes(notice.subtype ?? '')) {
        const dimension = notice.subtype === 'maxHeight' ? 'height' : notice.subtype === 'maxWidth' ? 'width' : 'weight';
        const actual = notice.details?.actual_value;
        return `Route exceeds the vehicle ${dimension} restriction${actual ? ` (${actual} ${notice.details?.unit ?? ''})` : ''}. Choose another route.`;
      }
    }
  }
  return null;
}
